// Guardia riutilizzabile per la chiusura delle modali con modifiche non salvate.
// Centralizza la logica in un unico punto: tutti i percorsi di chiusura di una
// modale (bottone di chiusura/Annulla, click fuori, ESC) devono passare da
// requestClose(). Se non ci sono modifiche pendenti la modale si chiude subito;
// se ci sono, mostra la conferma custom (DiscardChangesModal) invece dei popup
// nativi del browser. Non altera né rimuove i comportamenti di chiusura
// esistenti: li fa solo transitare da qui.
export default {
  data() {
    return {
      // Stato della conferma "modifiche non salvate" + azione di chiusura sospesa.
      discardGuard: { open: false, pending: null },
    };
  },
  methods: {
    // Richiede la chiusura di una modale. isDirty: ci sono modifiche non salvate?
    // closeFn: funzione che chiude effettivamente la modale principale.
    requestClose(isDirty, closeFn) {
      if (!isDirty) {
        closeFn();
        return;
      }
      this.discardGuard.pending = closeFn;
      this.discardGuard.open = true;
    },
    // "Resta"/"Annulla": chiude solo la conferma, lascia aperta la principale.
    onDiscardStay() {
      this.discardGuard.open = false;
      this.discardGuard.pending = null;
    },
    // "Esci senza salvare": esegue la chiusura sospesa scartando le modifiche.
    onDiscardConfirm() {
      const closeFn = this.discardGuard.pending;
      this.discardGuard.open = false;
      this.discardGuard.pending = null;
      if (typeof closeFn === "function") closeFn();
    },
  },
};
